export function confirmDiscard() {
    return window.confirm("Are you sure you want to discard your changes?");
}
